import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDefaultRoute } from "../../../../constants/roles";

const PublicRoute = ({ children }) => {
  const navigate = useNavigate();
  const { isAuth, adminRole } = useSelector((state) => state.auth);

  useEffect(() => {
    // If user is authenticated, redirect them to their default route
    if (isAuth && adminRole) {
      navigate(getDefaultRoute(adminRole), { replace: true });
    }
  }, [isAuth, adminRole, navigate]);

  // Don't render if user is authenticated
  if (isAuth && adminRole) {
    return null;
  }

  return children;
};

export default PublicRoute;
